/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * BeDrive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ChangeWorkspaceInviteRoleBody} from './schemas/change-workspace-invite-role-body';

import type {ChangeWorkspaceMemberRoleBody} from './schemas/change-workspace-member-role-body';

import type {CreateWorkspaceBody} from './schemas/create-workspace-body';

import type {CreateWorkspace200} from './schemas/create-workspace200';

import type {DeleteWorkspace200} from './schemas/delete-workspace200';

import type {InviteWorkspaceMembersBody} from './schemas/invite-workspace-members-body';

import type {InviteWorkspaceMembers200} from './schemas/invite-workspace-members200';

import type {JoinWorkspace200} from './schemas/join-workspace200';

import type {ListWorkspaceInvites200} from './schemas/list-workspace-invites200';

import type {ListWorkspaceMembers200} from './schemas/list-workspace-members200';

import type {ListWorkspaces200} from './schemas/list-workspaces200';

import type {RemoveWorkspaceMember200} from './schemas/remove-workspace-member200';

import type {ResendWorkspaceInvite200} from './schemas/resend-workspace-invite200';

import type {RetrieveWorkspace200} from './schemas/retrieve-workspace200';

import type {UpdateWorkspaceBody} from './schemas/update-workspace-body';

import type {UpdateWorkspace200} from './schemas/update-workspace200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List workspaces
 */
export const listWorkspaces = (
  options?: SecondParameter<typeof orvalApiFetch<ListWorkspaces200>>,
) => {
  return orvalApiFetch<ListWorkspaces200>(
    {url: `/workspaces`, method: 'GET'},
    options,
  );
};
/**
 * @summary Create a workspace
 */
export const createWorkspace = (
  createWorkspaceBody: CreateWorkspaceBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateWorkspace200>>,
) => {
  return orvalApiFetch<CreateWorkspace200>(
    {
      url: `/workspaces`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createWorkspaceBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a workspace
 */
export const retrieveWorkspace = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveWorkspace200>>,
) => {
  return orvalApiFetch<RetrieveWorkspace200>(
    {url: `/workspaces/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a workspace
 */
export const updateWorkspace = (
  id: number,
  updateWorkspaceBody?: UpdateWorkspaceBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateWorkspace200>>,
) => {
  return orvalApiFetch<UpdateWorkspace200>(
    {
      url: `/workspaces/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateWorkspaceBody,
    },
    options,
  );
};
/**
 * @summary Delete a workspace
 */
export const deleteWorkspace = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<DeleteWorkspace200>>,
) => {
  return orvalApiFetch<DeleteWorkspace200>(
    {url: `/workspaces/${id}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary List members
 */
export const listWorkspaceMembers = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<ListWorkspaceMembers200>>,
) => {
  return orvalApiFetch<ListWorkspaceMembers200>(
    {url: `/workspace/${id}/members`, method: 'GET'},
    options,
  );
};
/**
 * @summary List invites
 */
export const listWorkspaceInvites = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<ListWorkspaceInvites200>>,
) => {
  return orvalApiFetch<ListWorkspaceInvites200>(
    {url: `/workspace/${id}/invites`, method: 'GET'},
    options,
  );
};
/**
 * @summary Remove member
 */
export const removeWorkspaceMember = (
  id: number,
  userId: number,
  options?: SecondParameter<typeof orvalApiFetch<RemoveWorkspaceMember200>>,
) => {
  return orvalApiFetch<RemoveWorkspaceMember200>(
    {url: `/workspace/${id}/member/${userId}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Invite members
 */
export const inviteWorkspaceMembers = (
  id: number,
  inviteWorkspaceMembersBody: InviteWorkspaceMembersBody,
  options?: SecondParameter<typeof orvalApiFetch<InviteWorkspaceMembers200>>,
) => {
  return orvalApiFetch<InviteWorkspaceMembers200>(
    {
      url: `/workspace/${id}/invite`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: inviteWorkspaceMembersBody,
    },
    options,
  );
};
/**
 * @summary Resend invite
 */
export const resendWorkspaceInvite = (
  id: number,
  inviteId: string,
  options?: SecondParameter<typeof orvalApiFetch<ResendWorkspaceInvite200>>,
) => {
  return orvalApiFetch<ResendWorkspaceInvite200>(
    {url: `/workspace/${id}/${inviteId}/resend`, method: 'POST'},
    options,
  );
};
/**
 * @summary Change member's role
 */
export const changeWorkspaceMemberRole = (
  id: number,
  memberId: number,
  changeWorkspaceMemberRoleBody: ChangeWorkspaceMemberRoleBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/workspace/${id}/member/${memberId}/change-role`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: changeWorkspaceMemberRoleBody,
    },
    options,
  );
};
/**
 * @summary Change invite's role
 */
export const changeWorkspaceInviteRole = (
  id: number,
  inviteId: string,
  changeWorkspaceInviteRoleBody: ChangeWorkspaceInviteRoleBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/workspace/${id}/invite/${inviteId}/change-role`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: changeWorkspaceInviteRoleBody,
    },
    options,
  );
};
/**
 * @summary Delete invite
 */
export const deleteWorkspaceInvite = (
  inviteId: string,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/workspace/invite/${inviteId}`, method: 'DELETE'},
    options,
  );
};
/**
 * Join a workspace using valid invite id.
 * @summary Join a workspace
 */
export const joinWorkspace = (
  inviteId: string,
  options?: SecondParameter<typeof orvalApiFetch<JoinWorkspace200>>,
) => {
  return orvalApiFetch<JoinWorkspace200>(
    {url: `/workspace/join/${inviteId}`, method: 'GET'},
    options,
  );
};
export type ListWorkspacesResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaces>>
>;
export type CreateWorkspaceResult = NonNullable<
  Awaited<ReturnType<typeof createWorkspace>>
>;
export type RetrieveWorkspaceResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspace>>
>;
export type UpdateWorkspaceResult = NonNullable<
  Awaited<ReturnType<typeof updateWorkspace>>
>;
export type DeleteWorkspaceResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspace>>
>;
export type ListWorkspaceMembersResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceMembers>>
>;
export type ListWorkspaceInvitesResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceInvites>>
>;
export type RemoveWorkspaceMemberResult = NonNullable<
  Awaited<ReturnType<typeof removeWorkspaceMember>>
>;
export type InviteWorkspaceMembersResult = NonNullable<
  Awaited<ReturnType<typeof inviteWorkspaceMembers>>
>;
export type ResendWorkspaceInviteResult = NonNullable<
  Awaited<ReturnType<typeof resendWorkspaceInvite>>
>;
export type ChangeWorkspaceMemberRoleResult = NonNullable<
  Awaited<ReturnType<typeof changeWorkspaceMemberRole>>
>;
export type ChangeWorkspaceInviteRoleResult = NonNullable<
  Awaited<ReturnType<typeof changeWorkspaceInviteRole>>
>;
export type DeleteWorkspaceInviteResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspaceInvite>>
>;
export type JoinWorkspaceResult = NonNullable<
  Awaited<ReturnType<typeof joinWorkspace>>
>;
